
import Vue from 'vue';
import OeamtcSelect, { OeamtcSelectValue } from '@components/new-styleguide/form/OeamtcSelect.vue';
import { formatVehicle } from '@/utils/vehicleFormat';
import { Component, Prop } from 'vue-property-decorator';
import { TripLog } from '@/generated-clients/myTrips';

@Component({
  name: 'VehicleSelect',
  components: {
    OeamtcSelect
  }
})
export default class VehicleSelect extends Vue {
  @Prop()
  private value: TripLog;

  @Prop({ required: true })
  private triplogs: TripLog[];

  @Prop({ default: false })
  private allVehiclesOption: boolean;

  @Prop()
  private disabled: boolean;

  private handleInput(index: number) {
    if (this.allVehiclesOption) {
      this.$emit('input', index === 0 ? undefined : this.triplogs[index - 1] );
    } else {
      this.$emit('input', this.triplogs[index]);
    }
  }

  get valueIndex() {
    if (!this.value && this.showAllVehiclesOption) {
      return 0;
    }
    if (!this.value && this.disabled) {
      return -1;
    }
    return this.triplogs.findIndex(tl => tl.vehicle.id === this.value.vehicle.id) + (this.showAllVehiclesOption ? 1 : 0);
  }

  get triplogOptions(): OeamtcSelectValue[] {
    const mappedTrips = this.triplogs.map(tl => ({
      name: formatVehicle(tl.vehicle),
      tagIcon: {
        value: tl.smartConnected ? 'tag_connected_car' : 'tag_car',
        color: tl.smartConnected ? '#0071bb' : (tl.archived ? '#f6f6f6' : '#ffdc00'),
        fill: tl.smartConnected ? 'white' : 'black',
        fillId: tl.archived ? 'oeamtc-gradient__neutral' : undefined,
        position: 7
      }
    }));
    return this.showAllVehiclesOption ? [{ name: 'Alle Fahrzeuge' }, ...mappedTrips] : mappedTrips;
  }

  get showAllVehiclesOption() {
    return this.allVehiclesOption && this.triplogs.length > 1;
  }
}
